import React, { Component } from 'react';
import $ from "jquery";
import {  Link } from 'react-router-dom';
import phone from './si-glyph-call.svg';
import fax from './si-glyph-phone-fax.svg';
require('bootstrap')

class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <footer className="footer">
                <div className="container borderTop1px">
                    <div className="row text-center">
                        <div className="col-4 text-center">
                            <img src="images/kanzlei-heckmann.jpg" alt="Logo"></img>
                        </div>
                        <div className="col-4 text-center">
                            <div className="row">
                                <div className="col-12 col-sm-12 col-md-4">
                                    <Link to="/anfahrt" className="nav-link whiteSpaceNoWrap"><small>Anfahrt</small></Link>
                                </div>
                                <div className="col-12 col-sm-12 col-md-4">
                                    <Link to="/impressum" className="nav-link"><small>Impressum</small></Link>
                                </div>
                                <div className="col-12 col-sm-12 col-md-4">
                                    <Link to="/datenschutz" className="nav-link whiteSpaceNoWrap"><small>Datenschutz</small></Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-4" text-center>
                            <ul className="list-inline">
                                <li className="">
                                    <img src={phone} alt="Anrufen" className="phone"></img> <small><a className="colorBlack" href="tel:+492115370700">+49 (211) 53 70 700</a></small>
                                </li>
                                <li className="">
                                    <img src={fax} alt="Fax" className="phone"></img> <small><a className="colorBlack" href="tel:+492115370773">+49 (211) 53 70 773</a></small>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/Footer.js